import portalRoutes from './portal/routes';
export default [
  {
    path: '/',
    alias: '/clients',
    name: 'clients',
    component: () => import(/* webpackChunkName: "clients" */ './index.vue'),
  },
  {
    path: '/clients/:id',
    name: 'clients.show',
    props: true,
    component: () => import(/* webpackChunkName: "clients" */ './show.vue'),
  },
  portalRoutes,
];
